// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jOaY","type":"styles_type__3EayM","choices":"styles_choices__1av0u"};